<template>
    <div class="containers">
        <!-- 搜索框 -->
        <div class="search-box">
            <el-input @blur="changeShowHot" @focus="getHot" @keyup.enter.native="searchQue" v-model="getselCon" placeholder="請問有甚麼可以幫到你？" class="w120"></el-input>
            <div v-if="showHot && hotquestions.length > 0" class="search-box-hot">
                <div v-if="hotquestions" class="hot-ques">熱門問題</div>
                <div @click="goMainBody(item.id, item.titleNameWithCulture)" class="hot-for-ques" v-for="(item, index) in hotquestions" :key="index">
                    {{ item.titleNameWithCulture }}
                </div>
            </div>
            <el-button @click="searchQue" type="primary" icon="el-icon-search">搜尋</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showHot: false,
            hotquestions: [],
            hotquestionss: [
                { titleNameWithCulture: '111', id: 25 },
                { titleNameWithCulture: '222', id: 36 },
                { titleNameWithCulture: '333', id: 38 },
                { titleNameWithCulture: '444', id: 39 },
                { titleNameWithCulture: '555', id: 40 }
            ]
        };
    },
    props: ['frompage'],
    computed: {
        getselCon: {
            get() {
                return this.$store.state.searchBox;
            },
            set(newVal) {
                this.$store.commit('changesearchBox', newVal);
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll, true);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    },
    methods: {
        changeShowHot() {
            setTimeout(() => {
                this.showHot = false;
            }, 500);
        },
        goMainBody(id, titleNameWithCulture) {
            gio('track', 'search_match', {
                channel: '幫助中心',
                // location: `幫助中心${this.frompage}_搜索框`,
                location: '幫助中心搜索_搜索框',
                match_keywords_click: titleNameWithCulture,
                match_result_num: this.hotquestions.length,
                match_type: '幫助中心',
                // page: `幫助中心${this.frompage}`,
                page: '幫助中心搜尋網頁',
                platform: 'web'
            });
            gio('evar.set', {
                evar_ad_position: `幫助中心${this.frompage}_${titleNameWithCulture}`,
                evar_page: `幫助中心${this.frompage}`
            });
            if (this.$route.path == '/helpcenter/mainbody') {
                this.$store.commit('changefrompage', '幫助中心文章詳情頁');
                this.$emit('changeMainBody', id);
            } else {
                this.$store.commit('changefrompage', this.frompage);
                this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: id } });
            }
            let arr = [];
            if (JSON.parse(localStorage.getItem('questionId'))) {
                arr = JSON.parse(localStorage.getItem('questionId'));
            } else {
                arr = [];
            }
            arr = [...new Set(arr)];
            arr.unshift(id);
            if (arr.length > 5) {
                arr.pop();
            }
            localStorage.setItem('questionId', JSON.stringify(arr));
        },
        handleScroll() {
            this.showHot = false;
        },
        getHot() {
            this.axios.get(this.pub.getApi().GetHotQuestions, { params: { count: 5 } }).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.hotquestions = res.data.result;
                }
            });
            this.showHot = true;
        },
        searchQue() {
            gio('track', 'search', {
                channel: '幫助中心',
                input_type: '幫助中心',
                input_keywords: this.getselCon.trim(),
                location: `幫助中心${this.frompage}_搜索框`,
                page: `幫助中心${this.frompage}`,
                platform: 'web'
            });
            this.showHot = false;
            if (!this.getselCon.trim()) return;
            //* 可退回瀏覽歷史
            // this.$router.push({ name: this.pub.routeNameLists.HelpSearchResult, query: { selcon: this.$store.state.searchBox}});

            // 跳转到搜索结果页面
            this.$router.push({ name: this.pub.routeNameLists.HelpSearchResult });
        }
    },
    components: {}
};
</script>

<style scoped lang="less">
.containers {
    .search-box {
        text-align: left;
        .w120 {
            width: 45%;
            height: 46px;
            margin-right: 15px;
        }
        /deep/.el-input__inner {
            border-radius: 11px;
            height: 46px;
            &::placeholder {
                color: #999999;
            }
            &::-webkit-input-placeholder {
                color: #999999;
            }
            &:-moz-placeholder {
                color: #999999;
                opacity: 1;
            }
            &::-moz-placeholder {
                color: #999999;
                opacity: 1;
            }
            &:-ms-input-placeholder {
                color: #999999;
            }
        }
        .hot-ques {
            color: #444444;
            font-size: 14px;
            height: 44px;
            line-height: 44px;
            font-weight: 700;
            border-bottom: 1px solid #eeeeee;
        }
        .hot-for-ques {
            color: #444444;
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
        }
        .search-box-hot {
            width: 45%;
            padding: 0 12px;
            position: absolute;
            z-index: 1;
            top: 125px;
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 3px 4px 3px #efefef;
        }
    }
}
</style>
